import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "../../views/login/Login";
import PrivateRoute from "./PrivateRoute";
import HomeOptions from "../../views/home/Home";
import ConsultarStock from "../../views/consultarStock/ConsultarStock";
import Ordenes from "../../views/misOrdenes/Ordenes";

import MisAuditorias from "../../views/misAuditorias/MisAuditorias";
import DetalleAuditoria from "../../views/misAuditorias/detalleAuditoria/DetalleAuditoria";
import AuditarSMA from "../../views/auditarSMA/AuditarSMA";
import DetalleAuditaSMA from "../../views/auditarSMA/detalleAuditoriaSMA/DetalleAuditoriaSMA";
import DetalleOrden from "../../views/misOrdenes/omas/detalleOrden/DetalleOrden";
import Reubicaciones from "../../views/misReubicaciones/Reubicaciones";
import DetalleReubicacion from "../../views/misReubicaciones/detalleReubicacion/DetalleReubicacion";
import Manual from "../../views/manual/Manual";

const AppRoutes = ({ darkMode, setDarkMode, loggedUser }) => {
  const location = useLocation();

  // Ruta pública: manual de uso (no requiere autenticación)
  if (location.pathname === "/manual") {
    return <Manual />;
  }

  // Si no hay usuario logueado, redirige al login
  if (!loggedUser || Object.keys(loggedUser).length === 0) {
    return location.pathname === "/" ? <Login /> : <Navigate to="/" replace />;
  }

  return (
    <Routes>
      {/* Ruta pública */}
      <Route
        path="/"
        element={
          Object.keys(loggedUser).length > 0 ? (
            <Navigate to="/home" replace />
          ) : (
            <Login />
          )
        }
      />
      {/* Rutas privadas */}
      <Route
        path="/home"
        element={
          <PrivateRoute
            element={
              <HomeOptions darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/ordenes"
        element={
          <PrivateRoute
            element={<Ordenes darkMode={darkMode} setDarkMode={setDarkMode} />}
            loggedUser={loggedUser}
          />
        }
      />

      <Route
        path="/ordenes/:idomam"
        element={
          <PrivateRoute
            element={
              <DetalleOrden darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />

      <Route
        path="/auditorias"
        element={
          <PrivateRoute
            element={
              <MisAuditorias darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/auditorias/:idauds"
        element={
          <PrivateRoute
            element={
              <DetalleAuditoria darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/auditar-sma"
        element={
          <PrivateRoute
            element={
              <AuditarSMA darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/auditar-sma/:idauds"
        element={
          <PrivateRoute
            element={
              <DetalleAuditaSMA darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />

      <Route
        path="/reubicaciones"
        element={
          <PrivateRoute
            element={
              <Reubicaciones darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/reubicaciones/:idomam"
        element={
          <PrivateRoute
            element={
              <DetalleReubicacion
                darkMode={darkMode}
                setDarkMode={setDarkMode}
              />
            }
            loggedUser={loggedUser}
          />
        }
      />
      <Route
        path="/consultar-stock"
        element={
          <PrivateRoute
            element={
              <ConsultarStock darkMode={darkMode} setDarkMode={setDarkMode} />
            }
            loggedUser={loggedUser}
          />
        }
      />
      {/* Redirección por defecto */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
